import { useEffect } from 'react'

export const DY_ADD_TO_CART_EVENT = 'arcaplanet:add-to-cart'
export const DY_ADD_TO_CART_SUCCESS_EVENT = 'arcaplanet:add-to-cart:success'
export const DY_ADD_TO_CART_ERROR_EVENT = 'arcaplanet:add-to-cart:error'

// Payload sent by the DY recommendation JS (see data-dy-* on the product card).
// Solo sku e quantity sono usati: nome, prezzo e seller arrivano da VTEX tramite
// window.arcaplanet.cart.addItems, cosi' vale sempre il prezzo del carrello.
type DyAddToCartDetail = {
  requestId: string
  sku: string
  quantity?: number
}

const emit = (name: string, detail: { requestId: string; sku: string }) =>
  window.dispatchEvent(new CustomEvent(name, { detail }))

// Componente senza UI: adattatore dell'evento 'arcaplanet:add-to-cart' emesso
// dal JS delle campagne DY verso window.arcaplanet.cart.addItems (vedi
// CartApiHandler). Risponde con :success/:error.
const DynamicYieldAddToCartHandler = () => {
  useEffect(() => {
    const onAddToCart = async (event: Event) => {
      const { detail } = event as CustomEvent<DyAddToCartDetail>

      if (!detail?.requestId) return

      const { requestId, sku } = detail
      const qty = detail.quantity && detail.quantity > 0 ? detail.quantity : 1

      const addItems = window.arcaplanet?.cart?.addItems

      if (!sku || !addItems) {
        emit(DY_ADD_TO_CART_ERROR_EVENT, { requestId, sku })

        return
      }

      try {
        const { added } = await addItems([{ sku, qty }], { listName: '' })

        emit(
          added.length > 0
            ? DY_ADD_TO_CART_SUCCESS_EVENT
            : DY_ADD_TO_CART_ERROR_EVENT,
          { requestId, sku }
        )
      } catch (error) {
        console.error('DY add-to-cart failed', error)
        emit(DY_ADD_TO_CART_ERROR_EVENT, { requestId, sku })
      }
    }

    window.addEventListener(DY_ADD_TO_CART_EVENT, onAddToCart)

    return () => window.removeEventListener(DY_ADD_TO_CART_EVENT, onAddToCart)
  }, [])

  return null
}

export default DynamicYieldAddToCartHandler
